import { render, staticRenderFns } from "./ViewerHeaderBasic.vue?vue&type=template&id=e31f49c2&scoped=true"
import script from "./ViewerHeaderBasic.vue?vue&type=script&lang=js"
export * from "./ViewerHeaderBasic.vue?vue&type=script&lang=js"
import style0 from "./ViewerHeaderBasic.vue?vue&type=style&index=0&id=e31f49c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31f49c2",
  null
  
)

export default component.exports